var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({class:_vm.classes},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"am-card-footer-title"},[_vm._t("default")],2),(_vm.$slots['actions'])?_c('div',{staticClass:"am-card-footer-actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }